import { DRIVER_DASHBOARD, RIDER_DASHBOARD, AGENT_DASHBOARD, BOOKINGS_HISTORY, CURRENT_BALANCE,AGENT_BALANCE, AGENT_COMMISSION, AGENT_WITHDRAWALS, AGENT_WITHDRAW_SUBMIT } from 'App/store/constants';
import { MakeApiRequest } from 'App/common/Http';

export const loadDriverDashboard = () => {
  MakeApiRequest({
    server: 'taxi',
    url: 'dashboard/driver-dashboard',
    method: 'GET',
    nextActionType: DRIVER_DASHBOARD,
  });
};

export const loadRiderDashboard = () => {
  MakeApiRequest({
    server: 'taxi',
    url: 'dashboard/rider-dashboard',
    method: 'GET',
    nextActionType: RIDER_DASHBOARD,
  });
};

export const loadAgentDashboard = () => {
  MakeApiRequest({
    server: 'taxi',
    url: 'dashboard/agent-dashboard',
    method: 'GET',
    nextActionType: AGENT_DASHBOARD,
  });
};

export const loadAgentCurrentBalance = () => {
  MakeApiRequest({
    server: 'payment',
    url: 'party/agent/current/balance',
    method: 'GET',
    nextActionType: AGENT_BALANCE,
  });
};

// Commission summary: { balance, total, today, week, month, commission_series }
export const loadAgentCommission = () => {
  MakeApiRequest({
    server: 'payment',
    url: 'party/agent/commission/summary',
    method: 'GET',
    nextActionType: AGENT_COMMISSION,
  });
};

// Agent's own withdrawal history.
export const loadAgentWithdrawals = () => {
  MakeApiRequest({
    server: 'payment',
    url: 'withdraw/user/list',
    method: 'GET',
    nextActionType: AGENT_WITHDRAWALS,
  });
};

// Submit a withdrawal request. Returns the response promise so the caller can
// await + refresh. Uses a dedicated AGENT_WITHDRAW_SUBMIT action so a failed
// POST does not overwrite the AGENT_WITHDRAWALS history list with an error.
export const submitAgentWithdrawal = (zone_id: any, amount: number) =>
  MakeApiRequest({
    server: 'payment',
    url: 'withdraw/user/add',
    method: 'POST',
    data: { zone_id, amount },
    successMsg: true,
    errorMsg: true,
    nextActionType: AGENT_WITHDRAW_SUBMIT,
  });
export const loadBookingHistory = () => {
  MakeApiRequest({
    server: 'taxi',
    url: 'bookings/list',
    method: 'GET',
    nextActionType: BOOKINGS_HISTORY,
  });
};
export const loadBalance = () => {
  MakeApiRequest({
    server: 'payment',
    url: 'party/current/balance',
    method: 'GET',
    nextActionType: CURRENT_BALANCE,
  });
};
